import { Link } from "react-router-dom";
import empty from "../assets/images/empty.svg";
import Logo from "../shared-ui/Logo/Logo";

export default function NotFound() {
    return (
        <div className="flex items-center justify-center h-dvh md:h-screen px-8">
            <div
                className="w-[400px] max-w-full text-center rounded-md [border:1px_solid_var(--color-stroke)]
                 bg-[--card-bg-gray] shadow-[0px_16px_32px_-12px_#0e121b19] px-[--padding-card-x-lg] py-[--padding-card-y-lg]"
            >
                <Logo />
                <div className="mt-8 text-center">
                    <h2 className="text-title font-bold mb-3 text-text text-center">
                        The page you are trying to access does not exist
                    </h2>
                    <p className="text-sm">
                        You can access other parts of the app here{" "}
                        <Link to="/" className="link underline font-medium">
                            Dashboard
                        </Link>
                    </p>
                    <div>
                        <img src={empty} alt="" loading="lazy" />
                    </div>
                </div>
            </div>
        </div>
    );
}
